/* eslint-disable */
import React, { Component } from 'react';
import logo from '../assets/TB_web_header.png';

class Navigation extends Component {
  render() {
    return (
      <header className="header-1 region-0 block-0">
        <div className="container">
          <div className="row">

            <div id="logo-region" className="logo col-xs-12 col-md-3 text-center-sm">
              <a href="/"><img src={logo} alt="Home" className="logo" /></a>
            </div> {/* /logo-region */}

            <div id="menu-region" className="col-xs-12 col-md-9">
              <div className="region region-header">

                <div className="block block-menu hidden-md hidden-lg">


                  <div className="content">

                    <nav className="navbar nestor-main-menu" role="navigation">
                      {/* Menu button for mobile display */}
                      <div className="navbar-header">
                        <button type="button" className="navbar-toggle" data-toggle="collapse" data-target=".nav-collapse">MENU</button>
                      </div>


                    </nav>
                  </div>
                </div>

                <div className="block block-tb-megamenu">
                  <div className="content">
                    <div className="tb-megamenu tb-megamenu-main-menu">
                      <div className="nav-collapse  always-show">
                        <ul className="tb-megamenu-nav nav level-0 items-5">
                          <li className="tb-megamenu-item level-1 mega dropdown">
                            <a href="javascript:void(0)" className="dropdown-toggle" title="About">About<span className="caret"></span></a>
                            <div className="tb-megamenu-submenu dropdown-menu mega-dropdown-menu nav-child">
                              <div className="mega-dropdown-inner">
                                <div className="tb-megamenu-row row-fluid">
                                  <div className="tb-megamenu-column span3  mega-col-nav">
                                    <div className="tb-megamenu-column-inner mega-inner clearfix">
                                      <div className="tb-megamenu-block tb-block tb-megamenu-block">
                                        <div className="block-inner">
                                          <div className="block block-block">
                                            <div className="content">
                                              <h3>Welcome to The Branch Christian Church...</h3>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="tb-megamenu-column span3  mega-col-nav">
                                    <div className="tb-megamenu-column-inner mega-inner clearfix">
                                      <ul className="tb-megamenu-subnav mega-nav level-1 items-4">
                                        <li className="tb-megamenu-item level-2 mega padding-top-15">
                                          <a href="/WhoWeAre" >Who We Are</a>
                                        </li>
                                        <li className="tb-megamenu-item level-2 mega">
                                          <a href="/WhatWeBelieve" >What We Believe</a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  {/*<div className="tb-megamenu-column span4  mega-col-nav">
                                    <div className="tb-megamenu-column-inner mega-inner clearfix">
                                      <ul className="tb-megamenu-subnav mega-nav level-1 items-4">

                                        <li className="tb-megamenu-item level-2 mega padding-top-15">
                                          <a href="/WhatWeDo" >What We Do</a>
                                        </li>


                                        <li className="tb-megamenu-item level-2 mega padding-top-15">
                                          <a href="/MoreOnOurBeliefs" >More on What We Believe</a>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>*/}
                                </div>
                              </div>
                            </div>
                          </li>
                          <li className="tb-megamenu-item level-1 mega">
                            <a href="/Visit" >Visit Us</a>
                          </li>


                          <li className="tb-megamenu-item level-1 mega">
                            <a href="/WhoIsJesus" >What is the Good News?</a>
                          </li>

                          <li className="tb-megamenu-item level-1 mega">
                            <a href="https://thebranchcc.churchcenter.com/channels/17959" target="_blank" rel="noreferrer noopener">Sermons</a>
                          </li>
                          <li className="tb-megamenu-item level-1 mega">
                            <a href="/ContactInfo" >Contact</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>  </div>
            </div> {/* /menu-region */}

          </div> {/* /row */}
        </div> {/* /container */}
      </header >
    );
  }
}

export default Navigation;
